module.exports = __webpack_public_path__ + "media/SOC/dog-bd4a9259.svg";